export const selectActivityType = (activityType) => {

    return function(dispatch) {

        dispatch({
            type: "ACTIVITY_TYPE",
            payload: activityType
        })
    }
};


// WEBPACK FOOTER //
// ./src/actionCreators/selectActivityType.js